import { useEffect, useRef, useState } from "react";
import About from "../components/About";
import CallToAction from "../components/CallToAction";
import DesignedForPractice from "../components/DesignedForPractice";
import Hero from "../components/Hero";
import Listings from "../components/Listings";
import Marquee from "../components/Marquee";
import Opportunities from "../components/Opportunities";
import Outcomes from "../components/Outcomes";
import Partners from "../components/Partners";
import Placement from "../components/Placement";
import Programs from "../components/Programs";
import Program from "../components/Programs2";
import Stories from "../components/Stories";
import Testimonials from "../components/Testimonials";
import Trainers from "../components/Trainers";
import TrustBar from "../components/TrustBar";

function Home() {
  const pageRef = useRef(null);
  const [email, setEmail] = useState("");
  const [brochureText, setBrochureText] = useState("Download Brochure");
  const [emailError, setEmailError] = useState(false);
  const [activeListingTab, setActiveListingTab] = useState("jobs");
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  useEffect(() => {
    const root = pageRef.current;
    if (!root) {
      return undefined;
    }

    const revealItems = Array.from(root.querySelectorAll(".rv"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    revealItems.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTestimonialIndex((current) => (current + 1) % 3);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const root = pageRef.current;
    if (!root) {
      return;
    }

    root.querySelectorAll(".ltab").forEach((tab) => {
      tab.classList.toggle("active", tab.dataset.ltab === activeListingTab);
    });
  }, [activeListingTab]);

  useEffect(() => {
    const root = pageRef.current;
    if (!root) {
      return;
    }

    const track = root.querySelector("#testiTrack");
    const dots = root.querySelectorAll(".testi-dot");

    if (track) {
      track.style.transform = `translateX(-${testimonialIndex * 100}%)`;
    }

    dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === testimonialIndex);
    });
  }, [testimonialIndex]);

  useEffect(() => {
    const root = pageRef.current;
    if (!root) {
      return undefined;
    }

    const emailInput = root.querySelector("#em");
    const brochureButton = root.querySelector("#cb");
    const listingTabs = Array.from(root.querySelectorAll(".ltab"));
    const prevButton = root.querySelector("#testiPrev");
    const nextButton = root.querySelector("#testiNext");
    const dots = Array.from(root.querySelectorAll(".testi-dot"));

    const syncEmail = (event) => setEmail(event.target.value);
    const handleBrochure = () => {
      if (email && email.includes("@")) {
        setBrochureText("Sending...");
        window.setTimeout(() => {
          setBrochureText("Sent!");
          setEmail("");
          if (emailInput) {
            emailInput.value = "";
          }
          window.setTimeout(() => setBrochureText("Download Brochure"), 3000);
        }, 900);
        return;
      }

      setEmailError(true);
      window.setTimeout(() => setEmailError(false), 2000);
    };
    const handleTabClick = (event) => {
      setActiveListingTab(event.currentTarget.dataset.ltab);
    };
    const handlePrev = () =>
      setTestimonialIndex((current) => (current + 2) % 3);
    const handleNext = () =>
      setTestimonialIndex((current) => (current + 1) % 3);
    const handleDot = (event) => {
      setTestimonialIndex(Number(event.currentTarget.dataset.idx));
    };

    emailInput?.addEventListener("input", syncEmail);
    brochureButton?.addEventListener("click", handleBrochure);
    listingTabs.forEach((tab) => tab.addEventListener("click", handleTabClick));
    prevButton?.addEventListener("click", handlePrev);
    nextButton?.addEventListener("click", handleNext);
    dots.forEach((dot) => dot.addEventListener("click", handleDot));

    return () => {
      emailInput?.removeEventListener("input", syncEmail);
      brochureButton?.removeEventListener("click", handleBrochure);
      listingTabs.forEach((tab) =>
        tab.removeEventListener("click", handleTabClick),
      );
      prevButton?.removeEventListener("click", handlePrev);
      nextButton?.removeEventListener("click", handleNext);
      dots.forEach((dot) => dot.removeEventListener("click", handleDot));
    };
  }, [email]);

  useEffect(() => {
    const root = pageRef.current;
    if (!root) {
      return;
    }

    const emailInput = root.querySelector("#em");
    const brochureButton = root.querySelector("#cb");

    if (emailInput) {
      emailInput.style.borderColor = emailError ? "#E24B4A" : "";
    }

    if (brochureButton) {
      brochureButton.textContent = brochureText;
      brochureButton.style.background = brochureText === "Sent!" ? "#3B6D11" : "";
    }
  }, [brochureText, emailError]);

  return (
    <main ref={pageRef}>
      <Hero />
      {/* <Marquee /> */}
      <TrustBar />
       <Marquee />
      <About />
      {/* <Programs /> */}
      <Program />
       <Trainers />
      {/* <About /> */}
      {/* <DesignedForPractice /> */}
      {/* <Trainers /> */}
        {/* <Stories /> */}
     
      {/* <Outcomes /> */}
      {/* <Stories /> */}
      <Listings />
       <Opportunities />
      {/* <Placement /> */}
      <Testimonials />
      <Partners />
      <CallToAction />
    </main>
  );
}

export default Home;
